<template>
  <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" class="rc-currency-run" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width" ref="elFormItem">
    <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-input :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
              :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
              :value="formatValue"
              @input="changeFormatValue"
              @change="customChangeEvent"
              :placeholder="component.properties.placeholder"
              :disabled="disabled || component.properties.readonly"
              @focus="inputFocus(component, index)"
              @blur="validateFormItem">
      <template slot="append">{{ suffix }}</template>
    </el-input>
  </el-form-item>
</template>

<script>
import _ from 'lodash'
import { componentMixin, inputMixin, relFunMixin, calculationMixin } from './mixins'
export default {
  name: 'rc-currency',
  mixins: [ componentMixin, inputMixin, relFunMixin, calculationMixin ],
  props: ['component', 'value', 'index', 'disabled', 'custParams', 'labelParameter', 'tableCtrlKey'],
  data () {
    return {
      formatValue: ''
    }
  },
  created () {
    if (this.value !== undefined && this.value !== '' && this.value !== null) {
      this.changeFormatValue(this.value)
    }
  },
  methods: {
    changeFormatValue (value) {
      this.formatValue = value
      this.updateValue(value)
      this.$nextTick(() => this.executeFunctions('change'))
    },
    updateValue (value) {
      let number = this.convertToNumber(value)
      // 归档控件才需要传值
      if (this.component.archive.enable) {
        if (isNaN(parseFloat(value))) {
          this.update('')
        } else {
          this.update(number)
        }
      }
      this.formatValue = ''
      this.$nextTick(() => {
        number = this.handleNumber(number)
        this.formatValue = number
        // 触发值改变事件
        this.executeFunctions('change')
      })
    },
    convertToNumber (value) {
      let number = this.toNumber(value)
      // 百分比不需要舍入
      if (this.component.properties.numType !== 'percentage') {
        number = this.round(number)
      }
      // 复制过来的值转换为数字后可能为NaN
      if (isNaN(number)) {
        number = 0
      }
      return number
    },
    // 数字转千分位
    comdify (n) {
      // 负数时，负号直接拼接
      let plusMinusSign = ''
      if (n.startsWith('-')) {
        plusMinusSign = '-'
        n = n.slice(1)
      }
      let re = /\d{1,3}(?=(\d{3})+$)/g
      let afterComdifyNumber = n.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
        return s1.replace(re, '$&,') + s2
      })
      return plusMinusSign + afterComdifyNumber
    },
    // 提取全部的数字和第一位小数点
    toNumber (value) {
      // 如果开启了千分位, 处理数字时替换掉所有的逗号
      if (this.component.properties.bit) {
        value = value + ''
        value = value.replace(/,/g, '')
      }
      // 处理一类特殊数字 只包含 [-\d.]展示保留原值
      if (/^[-\d.]+$/.test(value)) {
        this.isSpecialNumber = true
        this.specialNumber = value
      } else {
        this.isSpecialNumber = false
      }
      if (value === '' || value === undefined || typeof value === 'number' || value === null) {
        return value
      }
      // let dot = value.replace(/[^.]/g, '').length
      // let result = value.replace(/[^\-\d.]/g, '')
      // // 若存在两个小数点再处理
      // if (dot > 1) {
      //   result = result.replace(/(\.[^.]*)./, '$1')
      // }
      // 先找到第一个小数点的索引
      value = value + ''
      let dotIndex = value.indexOf('.')
      // 再提取出所有的数字和负号
      let result
      if (value.match(/[\d-]/g)) {
        result = value.match(/[\d-]/g).reduce((prev, cv, ci) => {
          if (ci === dotIndex) {
            return prev + '.' + cv
          } else {
            return prev + cv
          }
        })
        if (dotIndex === 0) {
          result = '0.' + result
        }
      }
      return result
    },
    // 舍入
    round (value) {
      if (value === '' || value === undefined || value === null) {
        return value
      }
      // 数字先转字符串
      value = value + ''
      // 超过精度的数不再允许输入而是直接截取
      let precision = 0
      let dotIndex = value.indexOf('.')
      if (this.component.properties.numType === 'decimal') {
        precision = Number(this.component.properties.decimal) || 0
        if (dotIndex !== -1 && value.match(/\.\d+/) && value.match(/\.\d+/)[0].length - 1 > precision) {
          value = value.slice(0, dotIndex + precision + 1)
        }
      }
      return _.round(value, precision)
    },
    // 因为实时归档的原因,显式赋值时需要对00. -0 0.00等这类数字进行特殊处理展示, 实际归档的值依然是处理后的值 比如前面的不合理的都是0
    handleNumber (number) {
      // 如果是特殊数字 显式赋值
      if (this.isSpecialNumber) {
        number = this.specialNumber
      }
      number += ''
      // 处理小数点前面没有数字和多个小数点问题
      if (number.match(/\./g)) {
        let numberArray = number.split('')
        let dotIndex = number.indexOf('.')
        // 过滤掉多余的小数点
        numberArray = numberArray.filter((e, i) => {
          if (e === '.' && i !== dotIndex) {
            return false
          } else {
            return true
          }
        })
        // 在小数点前面不是数字的情况下给他加个0
        if (!/\d/.test(numberArray[dotIndex - 1])) {
          numberArray.splice(dotIndex, 0, '0')
        }
        number = numberArray.join('')
        let precision = Number(this.component.properties.decimal) || 0
        // 如果小数的位数超过了精度的位数, 则舍去后面几位
        if (this.component.properties.numType === 'decimal' && number.match(/\.\d+/) && number.match(/\.\d+/)[0].length - 1 > precision) {
          number = number.slice(0, dotIndex + precision + 1)
        } else if (this.component.properties.numType === 'num') {
          number = number.slice(0, dotIndex)
        }
      }
      // 开启了千分位展示
      if (this.component.properties.bit) {
        // 只有整数部分需要转, 小数部分直接拼接
        let integer = number
        let decimal = ''
        if (number.indexOf('.') !== -1) {
          integer = number.slice(0, number.indexOf('.'))
          decimal = number.slice(number.indexOf('.'))
        }
        integer = this.comdify(integer)
        number = integer + decimal
      }
      return number
    }
  },
  computed: {
    suffix () {
      switch (this.component.properties.currencyType) {
        case '人民币' :
          return '¥'
        case '美元' :
          return '$'
      }
    }
  },
  watch: {
    'value' (value) {
      if (value !== undefined && value !== null) {
        this.formatValue = this.convertToNumber(value)
      }
    }
  }

}
</script>
<style lang="scss">
  .process-runtime .rc-currency-run.el-form-item .el-form-item__content{
    line-height: 29px;
    height: 29px;
  }
  .rc-currency-run.el-form-item {
    .el-form-item__content {
      line-height: 28px;
      height: 28px;
    }
    .el-input-group__append {
      background: #f5f5f5;
      width: 36px;
      padding: 0;
      text-align: center;
      color: #181818;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-currency.vue